// WhyChooseWithUs.js
import React from "react";
import styled from 'styled-components';
import TripAssistant from "./AssistedModal";
import { CHAR_DHAM_DATA, CHAR_DHAM_EVENTS, CHAR_DHAM_IMAGES } from "../../../../../shared/config/constants"

const ListContainer = styled.ul`
  padding: 0;
  list-style-type: none;
`;

const ListItem = styled.li`
  display: flex;
  align-items: center;
  margin-bottom: 16px;
`;

const ListItemImage = styled.img`
  width: 32px;
  height: 32px;
  margin-right: 12px;
  border-radius: 8px;
`;

const ListItemText = styled.span`
  font-size: 18px;
  color: #333;
`;

const WhyChooseUsContainer = styled.div`
  background-color: white;
  margin-top: 20px;
  width: 100%;
  padding-left: 200px;
  display: flex;
  flex-direction: column;
  padding-right: 200px;

  @media (max-width: 1477px) {
    padding-left: 50px;
    padding-right: 50px;
  }
`;


const Container = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`

const ItineraryTitle = styled.p`
  margin-top: 24px;
  font-size: 24px;
  font-weight: bold;
  padding-bottom: 20px;
`;

const CustomizationContainer = styled.div`
  background-color: #16477f;
  border-radius: 32px;
  margin-left: 44px;
  display: flex;
  align-items: center;
  padding: 24px;
`;

const AssistantTextContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

const CustomizationText = styled.div`
  p:first-of-type {
    color: white;
    font-size: 24px;
    font-weight: bold;
  }

  p:last-of-type {
    margin-top: 8px;
    font-size: 18px;
    color: white;
  }
`;

const AssistantButton = styled.div`
  padding-left: 24px;
  padding-right: 24px;
  padding-top: 12px;
  padding-bottom: 12px;
  border-radius: 12px;
  background-color: #FF6D38;
  display: inline-block;
  text-align: center;
  width: fit-content;
  margin-top: 18px;
  cursor: pointer;
`;

const RouteImage = styled.img`
  width: 100%;
  padding-top: 20px;
  margin-bottom: 20px;
`;

const ListWithImages = ({ items }) => (
    <ListContainer>
      {items.map((item, index) => (
        <ListItem key={index}>
          <ListItemImage src={CHAR_DHAM_IMAGES.THUMB_IMG} alt="" />
          <ListItemText>{item}</ListItemText>
        </ListItem>
      ))}
    </ListContainer>
  );

const WhyChooseWithUs = ({ whyChooseUs, data, trackEvent }) => {
    const [showForm, setShowForm] = React.useState(false);

    const handleButtonClick = () => {
      trackEvent(`${CHAR_DHAM_EVENTS.TALK_TO_EXPERT}`);
      setShowForm(prev => !prev);
    };
    return (
    <>
      <WhyChooseUsContainer>
        <Container>
          <div>
            <ItineraryTitle>Why Choose Us?</ItineraryTitle>
            <ListWithImages items={whyChooseUs} />
          </div>
          <CustomizationContainer>
            <img
              src={CHAR_DHAM_IMAGES.ASSISTANT_GIRL}
              style={{ width: 148, marginRight: 20 }}
            />
            <AssistantTextContainer>
              <CustomizationText>
                <p>{CHAR_DHAM_DATA.ASSISTANT_TITLE}</p>
                <p>{CHAR_DHAM_DATA.ASSISTANT_SUBTITLE}</p>
              </CustomizationText>
              <AssistantButton onClick={handleButtonClick}>
                <p style={{ color: "white", fontWeight: "bold" }}>
                  Talk to an expert
                </p>
              </AssistantButton>
            </AssistantTextContainer>
          </CustomizationContainer>
        </Container>
        <RouteImage
          src={CHAR_DHAM_IMAGES.CHAR_DHAM_ROUTE}
          alt="Char Dham Route"
        />
      </WhyChooseUsContainer>
      <TripAssistant data={data} showForm={showForm} setShowForm={setShowForm}/>
    </>
    );
};

export default WhyChooseWithUs;
